var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M224 64c-44.2 0-80 35.8-80 80v48H80v-48C80 64.5 144.5 0 224 0s144 64.5 144 144v48h-64v-48c0-44.2-35.8-80-80-80",
  style: {
    opacity: 0.4
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 256c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z",
  className: "lock_svg__fa-primary"
})));
export default SvgLock;